import Vue from 'vue'

import { isEmail } from '@/helpers/validator'
import { normalizeFakeEmail } from '@/helpers/mailFake'

// helper function
const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

const SEND_INVITE_ROUTE = '/users/invite'
const GET_EMAIL_EXISTS = 'users/available/'

const form = {
  code: undefined,
  birthDate: undefined,
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  role: undefined,
  attributes: [],
  companyName: undefined,
  emailExists: false,
  emailEntered: false,
}

function initialState() {
  return {
    sendInvites: [Object.assign({}, form)],
    loadingValidation: false,
    loadingValidationMessage: '',
    loadingValidationErrors: [],
  }
}

const state = initialState()

const getters = {
  sendInvites: state => state.sendInvites,
  loadingValidation: state => state.loadingValidation,
  loadingValidationMessage: state => state.loadingValidationMessage,
  loadingValidationErrors: state => state.loadingValidationErrors,
}

const actions = {
  updateUserAttribute({ commit }, { values, userAttributeId, index }) {
    commit('setUserAttribute', { values, userAttributeId, index })
  },
  async loadInviteUsers({ commit, state }, users) {
    commit('setLoadingValidation', true)
    await asyncForEach(users, async (user, index) => {
      // insert user to form
      commit('appendFormInstanceWithValue', user)

      // check if email exist
      const { email } = user
      if (!email || !isEmail(email)) {
        commit('updateEmailEntered', { index, entered: false })
        commit('updateEmailExist', { index, exist: false })
        return
      }

      let entered = false
      for (let i = 0; i < state.sendInvites.length; i++) {
        if (state.sendInvites[i].email === email && i !== index) {
          entered = true
        }
      }
      commit('updateEmailEntered', { index, entered })

      // validate email
      try {
        commit(
          'setLoadingValidationMessage',
          `${index + 1}/${users.length} : ${email}`
        )
        await Vue.axios.get(GET_EMAIL_EXISTS + email)
        commit('updateEmailExist', { index, exist: false })
      } catch (e) {
        commit(
          'addLoadingValidationError',
          `${email} :: ${e.response.data.message}`
        )
        commit('updateEmailExist', { index, exist: true })
      }
    })
    commit('setLoadingValidation', false)
  },
  doSendInvites({ state }, { sendNow, $can }) {
    const dataFormated = {
      invitedUsers: state.sendInvites.map(i => ({
        email: normalizeFakeEmail(i.email.trim()),
        profile: {
          lastname: i.lastName,
          firstname: i.firstName,
        },
        role: i.role,
        companyName: i.companyName,
        inactive: !sendNow,
        birthDate: i.birthDate,
        attributes: i.attributes,
        ...($can('super', 'user') && i.code && { code: i.code }),
      })),
    }
    return Vue.axios.post(SEND_INVITE_ROUTE, dataFormated)
  },
  validateSendInvitesForm({ commit }, prop) {
    commit('updateSendInviteForm', prop)

    if (prop.property === 'email' && prop.event === 'blur') {
      prop.entered = false
      prop.exist = false

      if (isEmail(prop.value || '')) {
        for (let i = 0; i < state.sendInvites.length; i++) {
          if (state.sendInvites[i].email === prop.value && i !== prop.index) {
            prop.entered = true
          }
        }

        commit('updateEmailEntered', prop)

        if (!prop.entered) {
          Vue.axios
            .get(GET_EMAIL_EXISTS + prop.value)
            .then(() => {
              commit('updateEmailExist', prop)
            })
            .catch(() => {
              prop.exist = true
              commit('updateEmailExist', prop)
            })
        } else {
          commit('updateEmailExist', prop)
        }
      } else {
        commit('updateEmailEntered', prop)
        commit('updateEmailExist', prop)
      }
    }
  },
}

const mutations = {
  setUserAttribute(state, { values, userAttributeId: key, index }) {
    const attributes = state.sendInvites[index].attributes.filter(
      a => a.key !== key
    )
    attributes.push(...values.map(value => ({ key, value })))

    state.sendInvites[index].attributes = attributes
  },

  resetLoadingValidation(state) {
    state.loadingValidationErrors = []
    state.loadingValidationMessage = ''
  },

  addLoadingValidationError(state, error) {
    state.loadingValidationErrors.push(error)
  },

  setLoadingValidation(state, loading) {
    state.loadingValidation = loading
  },

  setLoadingValidationMessage(state, message) {
    state.loadingValidationMessage = message
  },

  updateSendInviteForm(state, prop) {
    state.sendInvites[prop.index][prop.property] = prop.value
  },

  updateEmailExist(state, prop) {
    state.sendInvites[prop.index].emailExists = prop.exist
  },

  updateEmailEntered(state, prop) {
    state.sendInvites[prop.index].emailEntered = prop.entered
  },

  appendFormInstance(state) {
    state.sendInvites = state.sendInvites.concat([Object.assign({}, form)])
  },

  appendFormInstanceWithValue(state, value) {
    const instance = Object.assign({}, form, value)
    state.sendInvites = state.sendInvites.concat([instance])
  },

  removeFormInstance(state, { index }) {
    state.sendInvites = state.sendInvites.filter((_, i) => i !== index)
  },

  reset(state) {
    state.sendInvites = [Object.assign({}, form)]
  },

  clearForm(state) {
    state.sendInvites = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
